import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/state/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (Object.keys(to.query).length > 0) {
          resolve()
        }
        if (savedPosition) {
          resolve(savedPosition)
        }
        if (to.hash) {
          resolve({selector: to.hash})
        }
        resolve({x: 0, y: 0})
      }, 10)
    })
  },
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.external) {
    return next()
  }

  if (to.meta && to.meta.guest) {
    if (store.getters['auth/isAuthenticated']) {
      return next('/')
    }
    return next()
  }

  if (store.getters['auth/isAuthenticated']) {
    if (store.getters['auth/isPermitted'](to.meta.rule)) {
      return next()
    }
    return next('/')
  }
  return next({
    path: '/login',
    query:
      to.fullPath && to.fullPath !== '/' && to.fullPath !== '/logout' && to.fullPath !== '/404'
        ? {redirect: to.fullPath}
        : null,
  })
})

router.afterEach((to, from) => {
  document.title = store.getters['app/documentTitle'](to.name)
})

export default router
